import { schema } from 'normalizr';

const companyUser = new schema.Entity('companyUser');

export default companyUser;
